import {
  convertDateStringToDateTimezone_7,
  convertIosStringToDateDayjs,
  formatDateToString,
  toNumber,
} from "helper/common";
import React from "react";
const columns: any[] = [
  {
    key: "index",
    title: "STT",
    align: "center",
  },
  {
    key: "idVtyt",
    title: "Mã vật tư",
    align: "center",
    dataIndex: "idVtyt",
    width: 120,
  },
  {
    key: "tenTheoThuongMai",
    title: "Tên vật tư",
    align: "left",
    dataIndex: "tenTheoThuongMai",
    width: 250,
  },

  {
    key: "soQD",
    title: "Số QĐ thầu",
    align: "center",
    dataIndex: "decision",
    render: (value, record, index) => {
      return <>{record?.bidDecision?.decision}</>;
    },
  },
  {
    key: "hanSYT",
    title: "Hạn SYT",
    align: "center",
    dataIndex: "hanSYT",
    render: (value, record, index) => {
      return <>{formatDateToString(record?.bidDecision?.hanSYT)}</>;
    },
  },

  {
    key: "name",
    title: "Hạn thầu",
    align: "center",
    dataIndex: "name",
    render: (value, record, index) => {
      return (
        <>
          {" "}
          {formatDateToString(
            convertIosStringToDateDayjs(record?.bidDecision?.tuNgay, "YYYYMMDD")
          )}{" "}
          -
          {formatDateToString(
            convertIosStringToDateDayjs(
              record?.bidDecision?.denNgay,
              "YYYYMMDD"
            )
          )}
        </>
      );
    },
    width: 180,
  },
  {
    key: "soLuong",
    title: "Số lượng ",
    align: "right",
    dataIndex: "soLuong",
    render: (value, record, index) => {
      return <>{toNumber(record?.bidDecision?.soLuong)}</>;
    },
    width: 100,
  },
  {
    key: "soLuongNhapNCC",
    title: "SL đã nhập",
    align: "right",
    dataIndex: "soLuongNhapNCC",
    width: 100,
  },
  {
    key: "soLuongCanNhap",
    title: "SL cần nhập",
    align: "right",
    dataIndex: "soLuongCanNhap",
    render: (value, record, index) => {
      return (
        <>
          {toNumber(record?.bidDecision?.soLuong) -
            toNumber(record?.soLuongNhapNCC)}
        </>
      );
    },
    width: 100,
  },
];
export {columns};
